module.exports = __webpack_public_path__ + "img/antes_despues_187.a00c3561.png";